import React from "react";
import { CategoryType, type CategoryDetailProps } from "./types";
import { ThemeSection } from "./SearchResult/ThemeSection";
import { StockSection } from "./SearchResult/StockSection";
import { NewsSection } from "./SearchResult/NewsSection";
import { CryptoCardItem, StockCardItem, NewsItem } from "./SearchResult/types";
import { SearchOpenData } from "@features/api/openData";

/**
 * 分类详细页面组件
 * 显示单个分类的所有搜索结果，支持滚动浏览
 */
export const CategoryDetail: React.FC<CategoryDetailProps> = ({
  categoryType,
  data,
  onClose,
  originType,
}) => {
  // 渲染分类内容
  const renderCategoryContent = () => {
    switch (categoryType) {
      case CategoryType.STOCK_THEMES:
      case CategoryType.CRYPTO_THEMES:
        return (
          <ThemeSection
            type={
              categoryType === CategoryType.STOCK_THEMES ? "stock" : "crypto"
            }
            themes={data as SearchOpenData[]}
            showAll={true} // 详细页面显示所有内容
            onClose={onClose}
          />
        );

      case CategoryType.STOCKS:
        return (
          <StockSection
            type={"stock"}
            stocks={data as StockCardItem[]}
            showAll={true} // 详细页面显示所有内容
            onClose={onClose}
            originType={originType}
          />
        );

      case CategoryType.CRYPTO:
        return (
          <StockSection
            type={"crypto"}
            stocks={data as CryptoCardItem[]}
            showAll={true} // 详细页面显示所有内容
            onClose={onClose}
            originType={originType}
          />
        );

      case CategoryType.NEWS:
        return (
          <NewsSection
            news={data as NewsItem[]}
            showAll={true} // 详细页面显示所有内容
            onClose={onClose}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="flex-1 md:px-6 px-4 py-4">{renderCategoryContent()}</div>
  );
};
